"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ItemSelect = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var menu_button_1 = require("../../menu-button/menu-button");
var menu_item_1 = require("../../menu-button/menu-item");
function ItemSelect(_a) {
    var items = _a.items, selectedItem = _a.selectedItem, getItemLabel = _a.getItemLabel, onItemSelect = _a.onItemSelect, renderItem = _a.renderItem, buttonLabel = _a.buttonLabel, prefixTitle = _a.prefixTitle, className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.disableWhenSingle, disableWhenSingle = _c === void 0 ? true : _c, _d = _a.isGrouped, isGrouped = _d === void 0 ? false : _d, isSelected = _a.isSelected, secondaryLabel = _a.secondaryLabel;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    var renderMenuItems = function (itemsToRender, groupLabel) {
        return itemsToRender.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(menu_item_1.MenuItem, __assign({ onSelect: function () { return onItemSelect(item); }, className: isSelected(selectedItem, item) ? 'selected' : '' }, { children: renderItem(item, index) }), groupLabel ? "".concat(groupLabel, "-").concat(index) : index)); });
    };
    var renderGroups = function (groups) {
        return groups.map(function (group, groupIndex) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "menu-group" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "menu-group-title" }, { children: group.label })), renderMenuItems(group.items, group.label)] }), "group-".concat(groupIndex))); });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "item-select-container" }, { children: (0, jsx_runtime_1.jsx)(menu_button_1.MenuButton, __assign({ label: buttonLabel || (selectedItem ? getItemLabel(selectedItem) : ''), secondaryLabel: secondaryLabel, disabled: disabled || (disableWhenSingle && items.length === 1), prefixTitle: prefixTitle, className: (0, classnames_1["default"])('item-select-button', className) }, { children: isGrouped
                ? renderGroups(items)
                : renderMenuItems(items) })) })));
}
exports.ItemSelect = ItemSelect;
//# sourceMappingURL=item-select.js.map